import { ICONS } from "../../../assets/icons/index";

export const STATUS = [
  {
    id: 1,
    icon: ICONS?.scheduled,
    label: "Scheduled",
    key: "scheduled",
    status: 10,
    isSelected: false,
  },
  {
    id: 2,
    icon: ICONS?.runningCampaign,
    label: "Running",
    key: "running",
    status: 11,
    isSelected: false,
  },
  {
    id: 3,
    icon: ICONS?.completed,
    label: "Completed",
    key: "completed",
    status: 12,
    isSelected: false,
  },
  {
    id: 4,
    icon: ICONS?.draft,
    label: "Draft",
    key: "draft",
    status: 0,
    isSelected: false,
  },
  {
    id: 5,
    icon: ICONS?.alertIconError,
    label: "Stopped",
    key: "stopped",
    status: 8,
    isSelected: false,
  },
];

export const SORT = [
  {
    id: 1,
    heading: 'Sort By',
    options: [
      {
        id: 1,
        icon: ICONS?.newestFirst,
        label: 'Newest First',
        key: 'newest',
        status: 'desc',
        field: 'created_at',
        isSelected: true,
      },
      {
        id: 2,
        icon: ICONS?.oldestFirst,
        label: 'Oldest First',
        key: 'oldest',
        status: 'asc',
        field: 'created_at',
        isSelected: false,
      },
      {
        id: 3,
        icon: ICONS?.ascending,
        label: 'Name (A-Z)',
        key: 'name_asc',
        status: 'asc',
        field: 'name',
        isSelected: false,
      },
      {
        id: 4,
        icon: ICONS?.descending,
        label: 'Name (Z-A)',
        key: 'name_desc',
        status: 'desc',
        field: 'name',
        isSelected: false,
      },
    ],
  },
];
